import { patchRequest } from '@/core';
import { trips } from '@/requests';

export default async function updateTripOrdersRequest(id, patch) {
	let url = trips.getByIdPathOrdersSpecific(id);
	let response = await patchRequest(url, {}, patch);
	return response;
}
